__turbopack_context__.v({
  "addButton": "BottomNav-module__JpMf2G__addButton",
  "addButtonWrapper": "BottomNav-module__JpMf2G__addButtonWrapper",
  "iconWrapper": "BottomNav-module__JpMf2G__iconWrapper",
  "navContainer": "BottomNav-module__JpMf2G__navContainer",
  "navItem": "BottomNav-module__JpMf2G__navItem",
  "navItemActive": "BottomNav-module__JpMf2G__navItemActive",
});
